import React from 'react';
import Breadcrumb from '../shared/Breadcrumb';
import SideNav from './shared/SideNav';
import PatientList from './shared/PatientList';

const Patients = () => {
    return (  
        <div>
            <Breadcrumb title="Patients"></Breadcrumb>
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            <SideNav applyCssFor='patients' />
                        </div>
                        <div className="col-md-7 col-lg-8 col-xl-9">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-body">
                                             <PatientList title="List of Patients" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default Patients;